export default class ModalManager {
  constructor() {
    this.activeModal = null;
    this.trigger = null;
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  init() {
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-modal-open]');
      const closeButton = event.target.closest('[data-modal-close]');

      if (openButton) {
        this.open(document.getElementById(openButton.dataset.modalOpen), openButton);
      } else if (closeButton || event.target.matches('.modal.is-open')) {
        this.close();
      }
    });

    document.addEventListener('keydown', this.handleKeydown);
  }

  open(modal, trigger = document.activeElement) {
    if (!modal) {
      return;
    }

    this.activeModal = modal;
    this.trigger = trigger;
    const productField = modal.querySelector('input[name="product"]');

    if (productField && trigger?.dataset.product) {
      productField.value = trigger.dataset.product;
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      this.getFocusableElements()[0]?.focus();
    });
  }

  close() {
    if (!this.activeModal) {
      return;
    }

    const modal = this.activeModal;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    window.setTimeout(() => {
      modal.hidden = true;
    }, 250);
    this.activeModal = null;
    this.trigger?.focus();
  }

  getFocusableElements() {
    if (!this.activeModal) {
      return [];
    }

    return [...this.activeModal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    )];
  }

  handleKeydown(event) {
    if (!this.activeModal) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusable = this.getFocusableElements();
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}
